class HelperScript {
    settings = {
        id: 'helperScript',
        webPath: '/',
        debug: false,
        closeTarget: 'close',
        autoload: false,
        appendToSelector: 'body',
        fetchRequestHeaders: {},
        lang: 'en',
        defaultForm: 'doesWant',
        onLangSelected: lang => {},
        onOpenExternalForm: target => {
            const targetEl = document.querySelector(target);
            if (this.settings.debug && !targetEl) {
                console.error(`Не найдена внешняя форма: ${target}`);
            }
            if (targetEl) {
                targetEl.click();
            }
        },
    };
    logic = {};
    labels = {};
    answerList = [];

    constructor(settings) {
        this.loadLocalSettings();
        this.settings = {...this.settings, ...settings};
        const {debug, autoload} = this.settings;
        const {lastOpened} = this.localSettings;

        if (!debug && autoload && lastOpened) {
            return false;
        }

        this.setup();
    }

    setup() {
        this.loadData();
        this.createWrapper();
        this.wrapper.addEventListener("onCloseForm", () => this.onCloseForm());
        this.wrapper.addEventListener("onFormRender", () => this.onFormRender());
    }

    loadData() {
        if (this.settings.debug) {
            this.settings.fetchRequestHeaders = {cache: "no-store"};
        }
        Promise.all([this.loadLogic(), this.loadLabels()])
            .then(() => {
                this.onDataLoaded();
            });
    }

    onDataLoaded() {
        if (this.localSettings.isLangLoaded) {
            this.setForm(this.settings.defaultForm);
        } else
            this.setForm("chooseLanguage");

        this.wrapper.dispatchEvent(new CustomEvent("onFormRender"));
    }

    loadLogic() {
        return fetch(`${this.settings.webPath}/logic.json`, this.settings.fetchRequestHeaders)
            .then(response => response.text())
            .then(json => JSON.parse(json))
            .then(data => this.logic = data)
            .catch(err => err);
    }

    loadLabels() {
        return fetch(`${this.settings.webPath}/labels.${this.settings.lang}.txt`, this.settings.fetchRequestHeaders)
            .then(response => response.text())
            .then(data => this.labels = this.parseLabels(data))
            .catch(err => err);
    }

    parseLabels(rawLabels) {
        const processedData = {};
        rawLabels.match(/([^:]+:[^:]+)\n/gum)
            .forEach((raw) => {
                let [key, value] = raw.trim().match(/([^:]+)/gmu);
                processedData[key] = value.replaceAll("\n", " <br/>");
            });

        return processedData;
    }

    createForm(data) {
        const form = this.createElement('form', data);
        let title = this.getFormTitle(data);

        if (this.settings.debug) {
            title = data.description + ': ' + title;
        }

        const titleElement = this.createTitle(title);

        form.classList.add('wpcf7');
        form.classList.add('wpcf7-form');
        form.classList.add('init');

        form.appendChild(titleElement);

        const buttonList = data.buttons.map(buttonData => this.createButton(buttonData));
        buttonList.forEach(button => form.append(button));

        return form;
    }

    getFormTitle(data) {
        return data.title
            ? this.labels[`${data.title}-title`]
            : this.labels[`${data.name}-title`];
    }

    createTitle(title) {
        const element = document.createElement("span");
        element.classList.add("title");
        element.innerHTML = title;

        return element;
    }

    createButton(data) {
        let label = this.labels[`${data.name}-btn`];
        if (this.settings.debug) {
            const {action: {type, target}} = data;
            if (target !== this.settings.closeTarget) {
                if (type === 'form') {
                    const formData = this.getFormData(target);
                    if (formData && formData.description) {
                        label = formData.description + `: ${label}`;
                    } else {
                        console.error(`Не найден description для формы ${target}`);
                    }
                }
                if (type === 'extForm') {
                    label = `ext: ${label}`;
                }
            }
        }

        const button = this.createElement("button", data);
        button.innerHTML = label;
        button.setAttribute('type', "button");
        button.classList.add('btn');

        return button;
    }

    createAction(data) {
        let fn;
        const actionData = data.action;
        switch (actionData.type) {
            case "close":
                fn = () => this.closeForm();
                break;
            case "form":
                fn = () => {
                    let target = actionData.target;
                    if (target === this.settings.closeTarget) {
                        return this.closeForm();
                    }

                    if (typeof actionData.target === 'object') {
                        target = this.calculateTargetObject(target);
                    }

                    this.setForm(target);
                };
                break;
            case "extForm":
                fn = () => this.openExternalForm(actionData.target);
                break;
            case "link":
                fn = () => this.openLink(actionData.target);
                break;
            case "lang":
                fn = () => this.loadLang(actionData.target);
                break;
        }

        return () => {
            this.setAnswer(data.name);
            fn();
        };
    }

    loadLang(lang) {
        this.localSettings.isLangLoaded = true;
        this.saveLocalSettings();
        this.settings.onLangSelected(lang);
    }

    setAnswer(answer) {
        const found = this.answerList.find(el => el.form === this.form);
        if (!found) {
            this.answerList.push({
                form: this.form,
                value: answer,
            })
        } else {
            found.value = answer;
        }
    }

    getAnswer(formName) {
        const answer = this.answerList.find(el => el.form === formName);
        return answer && answer.value;
    }

    openLink(linkName) {
        const url = this.labels[`${linkName}-url`];
        url && window.open(url, '_self');
        if (this.settings.debug && !url) {
            console.error(`Не найдена ссылка: ${linkName}`);
        }

        this.closeForm();
    }

    openExternalForm(target) {
        this.settings.onOpenExternalForm(target);
    }

    getWrapper() {
        return this.wrapper;
    }

    getFormData(name) {
        return this.logic.forms.find(el => el.name === name);
    }

    createElement(tag, data = {}) {
        const element = document.createElement(tag);

        data.classList && (data.classList.forEach(className => element.classList.add(className)));
        data.action && (element.addEventListener(
            'click',
            this.createAction(data)
        ));

        return element;
    }

    createWrapper() {
        this.wrapper = this.createElement('div', {
            classList: ['popup-form', 'active'],
        });
        this.wrapper.id = `${this.settings.id}-wrapper`;

        let content = this.createElement('div', {classList: ['content']});
        let topLine = this.createElement('div', {classList: ['topLine']});

        topLine.append(this.createFormCloseButton());

        if (this.settings.debug) {
            topLine.append(this.createReloadLogicButton());
        }

        this.wrapper.append(topLine);
        this.wrapper.append(content);
    }

    createFormCloseButton() {
        let close = this.createElement('div', {classList: ['close']});
        close.addEventListener('click', () => this.closeForm());

        return close;
    }

    createReloadLogicButton() {
        let button = this.createElement('div', {classList: ['reload']});
        button.innerHTML = '⟳';
        button.addEventListener('click', () => this.reloadData());

        return button;
    }

    reloadData() {
        this.settings.defaultForm = this.form;
        this.loadData();
    }

    calculateTargetObject(target) {
        for (const [action, actionData] of Object.entries(target)) {
            let result = true;
            for (const [key, value] of Object.entries(actionData.condition)) {
                result = this.getAnswer(key) === value;
            }
            if (result) target = action;
        }

        return target;
    }

    setForm(name) {
        const formData = this.getFormData(name);
        if (this.settings.debug && !formData) {
            console.error(`Не найдена форма: ${name}`);
        }
        this.updateFormByData(formData);
    }

    updateFormByData(formData) {
        this.form = formData.name;

        const wrapper = this.getWrapper();
        const content = wrapper.querySelector('.content');
        const formElement = this.createForm(formData);

        content.innerHTML = '';
        content.append(formElement);
    }

    closeForm() {
        this.getWrapper().remove();
        this.saveLastDate();
        this.wrapper.dispatchEvent(new CustomEvent("onCloseForm"));
        delete this;
    }

    saveLastDate() {
        this.localSettings.lastOpened = new Date();
        this.saveLocalSettings();
    }

    loadLocalSettings() {
        this.localSettings = JSON.parse(localStorage.helperScript || '{}');
    }

    saveLocalSettings() {
        localStorage.helperScript = JSON.stringify(this.localSettings);
    }

    clearLocalSettings() {
        localStorage.removeItem("helperScript");
    }

    getAnswerLog() {
        let translated = '';
        for (const answerListElement of this.answerList) {//s
            const formData = this.getFormData(answerListElement.form);
            const title = this.getFormTitle(formData);
            const button = formData.buttons.find(el => el.name === answerListElement.value);
            const answer = this.labels[`${button.name}-btn`];
            translated += `${title}: ${answer}\n`;
        }
        console.info(translated);
    }

    onCloseForm() {
        document.querySelector(".popup-form .close, .popup-mask").click();
    }

    onFormRender() {
        const popupMask = document.querySelector(".popup-mask")
        popupMask.classList.add('active');
        document.querySelector("body")
            .style.overflow = "hidden";
        document.querySelector(this.settings.appendToSelector)
            .prepend(this.wrapper);
        return false;
    }
}

window.helperScriptClass = HelperScript;